import React, { SVGAttributes } from 'react';

const Tag = (props: SVGAttributes<SVGElement>) => (
    <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
        <path
            d="M16.912 27.25c-3.3-3.292-3.3-6.927 0-10.218 3.29-3.292 6.92-3.292 10.21 0m-10.21-3.405 6.81 6.811m-10.22-3.406 5.11 5.108M30.163 11.242a2.408 2.408 0 1 0 0-4.817 2.408 2.408 0 0 0 0 4.817Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M35.922 1h-15.62c-.71 0-1.39.293-1.88.812L1.702 19.597a2.574 2.574 0 0 0-.7 1.882c.04.696.35 1.347.88 1.804l16.72 14.582c1.04.911 2.62.832 3.57-.18l15.64-16.695c.44-.475.69-1.1.69-1.752V3.567c0-.682-.27-1.336-.76-1.817a2.553 2.553 0 0 0-1.82-.75Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Tag;
